import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "../../../../components/Button/button";
import "bootstrap/dist/css/bootstrap.min.css";

import {
  CreateMovimentacaoDto,
  GetMovimentacaoDto,
} from "../../../../shared/dtos/Movimentacao.dto";
import InputComponent from "../../../../components/Input/input";
import Swal from "sweetalert2";
import movimentacaoService from "../../../../services/MovimentacaoService";
import dependenteService from "../../../../services/DependenteService";
import contribuinteService from "../../../../services/ContribuinteService";
import { Label } from "../../../../components/Label/styles";
import SelectComponent from "../../../../components/Select/select";
import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../../../components/Table/styles";
import { Colors } from "../../../../shared/colors/colors";
import {
  DisplayField,
  InputContainer,
  MainContainer,
  RowContainer,
  SelectContainer,
  Textarea,
  TextareaContainer,
} from "./styles";
import { GetTipoExclusaoDTO } from "../../../../shared/dtos/TipoExclusao.dto";
import tipoExclusaoService from "../../../../services/TipoExclusaoService";
import { GetDependenteDto } from "../../../../shared/dtos/Dependente.dto";
import { useNavigate } from "react-router-dom";
import {
  BlueTitle,
  LoadingGif,
  LoadingOverlay,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Space,
} from "../../../../shared/styles/global.styles";
import loadSCGif from "../../../../assets/load_SC.gif";
import { GetContribuinteDto } from "../../../../shared/dtos/Contribuinte.dto";
import { IoCloseSharp } from "react-icons/io5";
import { ContainerButtons, ContainerFilter } from "../../style";

interface Props {
  contribuinteData: GetContribuinteDto;
  setContribuinteData: React.Dispatch<React.SetStateAction<GetContribuinteDto>>;
  isNewContribuinte: boolean;
  setIsNewContribuinte: () => void;
  newDependenteData?: GetDependenteDto | undefined;
  setNewDependenteData: React.Dispatch<
    React.SetStateAction<GetDependenteDto | undefined>
  >;
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>;
  newFlow: boolean;
  setNewFlow: React.Dispatch<React.SetStateAction<boolean>>;
  editOnly: boolean;
}

const MovimentacaoPage: React.FC<Props> = ({
  contribuinteData,
  setContribuinteData,
  isNewContribuinte,
  setIsNewContribuinte,
  newDependenteData,
  setNewDependenteData,
  setSelectedTab,
  newFlow,
  setNewFlow,
  editOnly,
}) => {
  const [isNewDependente, setIsNewDependente] = useState(
    newDependenteData ? true : false
  );
  const [movimentacoes, setMovimentacoes] = useState<GetMovimentacaoDto[]>([]);
  const [showModal, setShowModal] = useState(
    isNewDependente || isNewContribuinte || false
  );
  const [tipo, setTipo] = useState<"INCLUSAO" | "EXCLUSAO" | "REATIVACAO" | "">(
    isNewDependente || isNewContribuinte ? "INCLUSAO" : ""
  );
  // Adicione um novo estado para controlar se é uma edição
  const [isEditing, setIsEditing] = useState(false);

  const [dataMovimentacao, setDataMovimentacao] = useState<string>(
    new Date().toISOString().split("T")[0]
  );
  const [dataFimCarencia, setDataFimCarencia] = useState<string | null>(null);
  const [observacao, setObservacao] = useState("");
  const [dependentes, setDependentes] = useState<any[]>([]);
  const [dependenteSelecionado, setDependenteSelecionado] = useState<
    number | null
  >(isNewDependente ? newDependenteData?.id! : null);
  const [contribuinte, setContribuinte] = useState<any>(null);
  const [loading, setLoading] = useState(true); // Estado de carregamento
  const [isRequest, setIsRequest] = useState<boolean>(false);

  const [showMovimentacoesModal, setShowMovimentacoesModal] = useState(false);

  const [tipoExclusao, setTipoExclusao] = useState<GetTipoExclusaoDTO[]>([]);
  const [motivoExclusao, setMotivoExclusao] = useState<number>();

  const [dependentesCadastrados, setDependentesCadastrados] = useState<
    GetDependenteDto[]
  >([]);

  const [erroMotivoExclusao, setErroMotivoExclusao] = React.useState(false);

  const [invalidFields, setInvalidFields] = useState<string[]>([]); // Estado para campos inválidos

  // const validarCampos = () => {
  //   if (tipo === "EXCLUSAO" && !motivoExclusao) {
  //     setErroMotivoExclusao(true); // Define erro se nenhum motivo for selecionado
  //     return false; // Impede o prosseguimento
  //   }
  //   setErroMotivoExclusao(false); // Limpa o erro se estiver válido
  //   return true; // Permite o prosseguimento
  // };

  // const handleCadastrarDependente = () => {
  //   if (dependenteSelecionado) {
  //     const dependente = dependentes.find(
  //       (d) => d.id === dependenteSelecionado
  //     );
  //     if (dependente) {
  //       setDependentesCadastrados([...dependentesCadastrados, dependente]);
  //     }
  //   }
  // };

  const fetchTipoExclusao = async () => {
    await tipoExclusaoService
      .getAll()
      .then((response) => {
        setTipoExclusao(response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchMovimentacoes = async () => {
    try {
      setLoading(true);
      const data = await movimentacaoService.getMovimentacoesByContribuinte(
        contribuinteData.id
      );
      setMovimentacoes(data);
    } catch (error) {
      console.error("Erro ao buscar movimentações:", error);
      Swal.fire(
        "Erro",
        "Erro ao carregar movimentações. Tente novamente mais tarde.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchDependentes = async () => {
    try {
      setLoading(true);
      const data = await dependenteService.getAllDependentesByContribuinte(
        contribuinteData.id
      );
      setDependentes(data);
    } catch (error) {
      console.error("Erro ao buscar dependentes:", error);
      Swal.fire(
        "Erro",
        "Erro ao carregar dependentes. Tente novamente mais tarde.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const limparModal = () => {
    const calculatedDate = calculateDataFimCarencia(
      new Date().toISOString().split("T")[0]
    );
    setTipo(""); // Resetar o tipo de movimentação para "Selecione"
    setDataMovimentacao(new Date().toISOString().split("T")[0]); // Resetar a data de movimentação
    setDataFimCarencia(calculatedDate); // Resetar a data final da carência
    setObservacao(""); // Resetar a observação
    setDependenteSelecionado(null); // Resetar o dependente selecionado
    setErroMotivoExclusao(false); // Limpa o estado de erro
    setMotivoExclusao(0); // Limpar o motivo da exclusão
    setIsNewContribuinte();
    setIsNewDependente(false);
    setNewDependenteData(undefined);
  };
  const fetchContribuinte = async () => {
    try {
      setLoading(true);
      const data = await contribuinteService.getContribuinteById(
        contribuinteData.id
      );
      setContribuinte(data);
    } catch (error) {
      console.error("Erro ao buscar contribuinte:", error);
      Swal.fire("Erro", "Erro ao carregar os dados do contribuinte.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMovimentacoes();
    fetchDependentes();
    fetchContribuinte();
    fetchTipoExclusao();
  }, [contribuinteData.id]);

  useEffect(() => {
    if (newDependenteData) {
      const dependenteExistente = dependentes.some(
        (dep) => dep.id === newDependenteData.id
      );
      if (dependenteExistente) {
        setIsNewDependente(true); // Marca como novo dependente
        setShowModal(true); // Abre o modal
        setDependenteSelecionado(newDependenteData.id); // Seleciona o novo dependente
        setTipo("INCLUSAO"); // Define tipo como "INCLUSAO"
      } else {
        setShowModal(false); // Fecha o modal caso não haja dependente novo
      }
    }
  }, [newDependenteData, dependentes]);

  // Verifica se o modal deve ser exibido,
  // Se houver mudanças rápidas nos estados, haverá um pequeno atraso antes de abrir o modal.
  useEffect(() => {
    if (!isEditing) {
      const timer = setTimeout(() => {
        setShowMovimentacoesModal(isNewContribuinte || isNewDependente);
      }, 200); // Atraso de 200ms
      return () => clearTimeout(timer);
    } else {
      setShowMovimentacoesModal(false);
    }
  }, [isNewContribuinte, isNewDependente, isEditing]);

  const handleClose = () => setShowModal(false);
  const handleShow = () => {
    setTipo(""); // Garantir que o valor inicial seja vazio, mostrando "Selecione"
    const calculatedDate = calculateDataFimCarencia(
      new Date().toISOString().split("T")[0]
    );
    setDataFimCarencia(calculatedDate);
    setDependenteSelecionado(null);
    setShowModal(true);
    limparModal();
  };

  const handleValidate = async () => {
    setIsRequest(true);

    // Validação dos campos obrigatórios
    if (!dataMovimentacao || !tipo) {
      Swal.fire(
        "Atenção",
        "Por favor, preencha os campos obrigatórios.",
        "warning"
      );
      setIsRequest(false); // Reseta o estado de requisição
      return;
    }

    // Validação específica para o tipo "EXCLUSAO"
    if (tipo === "EXCLUSAO" && !motivoExclusao) {
      Swal.fire(
        "Atenção",
        "Por favor, selecione o motivo da exclusão.",
        "warning"
      );
      setInvalidFields((prev) => {
        if (!prev.includes("motivoExclusao"))
          return [...prev, "motivoExclusao"];
        return prev;
      });
      setIsRequest(false); // Reseta o estado de requisição
      return;
    }

    // Exibe o alerta de "Aguarde"
    Swal.showLoading();
    Swal.fire({
      icon: "info",
      title: "Aguarde",
      text: "Processando a movimentação...",
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading(); // Exibe o ícone de carregamento
      },
    });

    // Cria o objeto para envio
    const novaMovimentacao: CreateMovimentacaoDto = {
      data_movimentacao: dataMovimentacao,
      tipo,
      data_fim_carencia: dataFimCarencia || undefined,
      observacao,
      id_contribuinte: contribuinteData.id,
      id_dependente: dependenteSelecionado ?? undefined,
      tipo_exclusao_id: tipo === "EXCLUSAO" ? motivoExclusao : undefined, // Inclui o motivo da exclusão
    };

    await movimentacaoService
      .createMovimentacao(novaMovimentacao)
      .then(async (response) => {
        setContribuinteData((prev) => ({
          ...prev,
          LastMovimentacao:
            novaMovimentacao.id_dependente === undefined
              ? { ...novaMovimentacao, id: response.movimentacao.id }
              : prev.LastMovimentacao,
        }));
        contribuinteData = {
          ...contribuinteData,
          LastMovimentacao: {
            ...novaMovimentacao,
            id: response.movimentacao.id,
          },
        };
        Swal.close(); // Fecha o alerta de "Aguarde"

        if (tipo === "EXCLUSAO") {
          // Apenas finaliza sem perguntar nada após a exclusão
          await Swal.fire({
            title: "Exclusão realizada com sucesso!",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          handleClose();
          setIsRequest(false);

          // Atualiza a lista de movimentações e limpa o modal
          limparModal();
          await fetchMovimentacoes();
          return; // Encerra aqui, sem perguntas adicionais
        }

        // Lógica para outros tipos de movimentação
        if (newFlow) {
          const result = await Swal.fire({
            title: "Movimentação criada com sucesso.",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });

          if (result.isConfirmed) {
            const { value: result } = await Swal.fire({
              title: "Deseja cadastrar um novo dependente?",
              icon: "question",
              html: `
                <button id="swal-confirm" class="swal2-confirm swal2-styled">
                  Sim, Quero cadastrar um novo dependente!
                </button>
                <button id="swal-cancel" class="swal2-cancel swal2-styled">
                  Não, ir para dados financeiros.
                </button>
                <button id="swal-deny" class="swal2-deny swal2-styled">
                  Não, finalizar cadastro!
                </button>
              `,
              customClass: {
                actions: "swal2-actions-column", // Coloca os botões em coluna
              },
              showConfirmButton: false,
              showCancelButton: false,
              showDenyButton: false,
              focusConfirm: false,
              allowOutsideClick: false,
              didOpen: () => {
                // Adiciona eventos de clique aos botões personalizados
                const confirmButton = document.getElementById("swal-confirm");
                const cancelButton = document.getElementById("swal-cancel");
                const denyButton = document.getElementById("swal-deny");

                if (confirmButton) {
                  confirmButton.addEventListener("click", () => {
                    Swal.close(); // Fecha o modal
                    setSelectedTab(1); // Navega para a aba de cadastro de dependentes
                  });
                }

                if (cancelButton) {
                  cancelButton.addEventListener("click", () => {
                    Swal.close(); // Fecha o modal
                    setSelectedTab(2); // Navega para a aba de dados financeiros
                  });
                }

                if (denyButton) {
                  denyButton.addEventListener("click", () => {
                    setNewFlow(false);
                    Swal.close(); // Fecha o modal
                    setSelectedTab(0); // Navega para a aba de dados financeiros
                  });
                }
              },
            });
            
          }
          setIsRequest(false);
        } else {
          // Alerta de sucesso para movimentações que não sejam exclusões
          await Swal.fire({
            title: "Sucesso",
            text: "Movimentação criada com sucesso!",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          handleClose();
          setIsRequest(false);
        }

        // Limpa o modal após o cadastro
        limparModal();

        // Atualiza a lista de movimentações
        await fetchMovimentacoes();
      })
      .catch((error) => {
        setIsRequest(false);

        let errorMessage =
          "Ocorreu um erro ao registrar a movimentação. Tente novamente.";

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        } else if (error && error.message) {
          errorMessage = error.message;
        } else if (typeof error === "string") {
          errorMessage = error;
        }

        Swal.fire("Atenção", errorMessage, "warning");
      });
  };

  const formatDate = (date: string | Date | undefined): string => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleDateString();
    } catch {
      return "Data inválida";
    }
  };

  const calculateDataFimCarencia = (data: string): string => {
    const date = new Date(data);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 180);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (tipo === "INCLUSAO" || tipo === "REATIVACAO") {
      const calculatedDate = calculateDataFimCarencia(dataMovimentacao);
      setDataFimCarencia(calculatedDate);
    } else if (tipo === "EXCLUSAO") {
      setDataFimCarencia("");
    }
  }, [tipo, dataMovimentacao]);

  const clearError = async (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = event.target;

    // Remove todos os caracteres não numéricos para trabalhar apenas com números
    const numericValue = value.replace(/\D/g, "");

    switch (name) {
      case "motivoExclusao":
        setInvalidFields((prev) =>
          prev.filter((field) => field !== "motivoExclusao")
        );

        break;
      default:
        setInvalidFields((prev) => prev.filter((field) => field !== name));
        break;
    }
  };

  return (
    <MainContainer>
      <div className="page contribuinte">
        <div className="body taxpayer">
          {loading ? (
            <LoadingOverlay>
              <LoadingGif src={loadSCGif} alt="Carregando..." />
            </LoadingOverlay>
          ) : (
            <>
              {editOnly && (
                <ContainerFilter>
                  <div></div>
                  <ContainerButtons>
                    <Button schemaButton="full-primary" action={handleShow}>
                      Nova Movimentação
                    </Button>
                  </ContainerButtons>
                </ContainerFilter>
              )}
              <TableContainer style={{ flex: 1 }}>
                <Table firstColSmall={true} id="tabela-ficha-financeira">
                  <TableHead>
                    <TableRow
                      style={{
                        backgroundColor: Colors.primary,
                        color: Colors.white,
                      }}
                    >
                      <TableHeader>Tipo</TableHeader>
                      <TableHeader>Movimentação</TableHeader>
                      <TableHeader>Fim carência</TableHeader>
                      <TableHeader>Observação</TableHeader>
                      <TableHeader>Motivo exclusão</TableHeader>
                    </TableRow>
                  </TableHead>
                  <tbody>
                    {movimentacoes.length === 0 ? (
                      <TableRow>
                        <TableData
                          colSpan={8}
                          className="text-center text-muted"
                        >
                          Não há movimentações cadastradas.
                        </TableData>
                      </TableRow>
                    ) : (
                      <>
                        {/* Bloco para o contribuinte */}
                        {Object.entries(
                          movimentacoes
                            .filter((mov) => !mov.dependente)
                            .reduce(
                              (
                                acc: Record<string, typeof movimentacoes>,
                                mov
                              ) => {
                                const contribuinteNome =
                                  mov.contribuinte?.nome ||
                                  "Contribuinte Desconhecido";
                                if (!acc[contribuinteNome])
                                  acc[contribuinteNome] = [];
                                acc[contribuinteNome].push(mov);
                                return acc;
                              },
                              {}
                            )
                        ).map(
                          (
                            [contribuinteNome, movimentacoesContribuinte],
                            index
                          ) => (
                            <>
                              <TableRow key={`contribuinte-header-${index}`}>
                                <TableData
                                  colSpan={6}
                                  style={{
                                    textAlign: "left",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Contribuinte:{" "}
                                  <span style={{ color: "#2563EB" }}>
                                    {contribuinteNome}
                                  </span>
                                </TableData>
                              </TableRow>

                              {(
                                movimentacoesContribuinte as typeof movimentacoes
                              ).map((movimentacao, idx) => (
                                <TableRow key={`contribuinte-${index}-${idx}`}>
                                  <TableData
                                    style={{
                                      color:
                                        movimentacao.tipo === "INCLUSAO" ||
                                        movimentacao.tipo === "REATIVACAO"
                                          ? Colors.success
                                          : "inherit",
                                    }}
                                  >
                                    {movimentacao.tipo}
                                  </TableData>
                                  <TableData>
                                    {new Date(
                                      movimentacao.data_movimentacao
                                    ).toLocaleDateString("pt-BR", {
                                      timeZone: "UTC",
                                    })}
                                  </TableData>
                                  <TableData>
                                    {movimentacao.data_fim_carencia
                                      ? new Date(
                                          movimentacao.data_fim_carencia
                                        ).toLocaleDateString("pt-BR", {
                                          timeZone: "UTC",
                                        })
                                      : ""}
                                  </TableData>
                                  <TableData>
                                    {movimentacao.observacao || "Nenhuma"}
                                  </TableData>
                                  <TableData
                                    style={{
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {movimentacao.tipoExclusao?.nome ||
                                      "Nenhuma"}
                                  </TableData>
                                </TableRow>
                              ))}
                            </>
                          )
                        )}

                        {/* Blocos separados para cada dependente */}
                        {Object.entries(
                          movimentacoes
                            .filter((mov) => mov.dependente)
                            .reduce(
                              (
                                acc: Record<string, typeof movimentacoes>, // Chave agora é string do ID
                                mov
                              ) => {
                                const dependenteId = mov.dependente?.id?.toString() || "desconhecido"; // Use ID como chave única (converta para string)
                                const dependenteNome = mov.dependente?.nome || "Dependente Desconhecido";
                                
                                if (!acc[dependenteId]) {
                                  acc[dependenteId] = []; // Inicializa array para este ID
                                }
                                acc[dependenteId].push(mov);
                                return acc;
                              },
                              {}
                            )
                        ).map(([dependenteId, movimentacoesDependente], index) => {
                          // Pegue o nome do primeiro item do grupo (assumindo consistência no grupo)
                          const dependenteNome = movimentacoesDependente[0]?.dependente?.nome || "Dependente Desconhecido";
                          
                          return (
                            <>
                              <TableRow key={`dependente-header-${index}`}>
                                <TableData
                                  colSpan={6}
                                  style={{
                                    textAlign: "left",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Dependente:{" "}
                                  <span style={{ color: "#2563EB" }}>
                                    {dependenteNome} { /* Opcional: (ID: {dependenteId}) para distinguir homônimos */ }
                                  </span>
                                </TableData>
                              </TableRow>
                              {movimentacoesDependente.map((movimentacao, idx) => (
                                <TableRow key={`dependente-${index}-${idx}`}>
                                  <TableData
                                    style={{
                                      color:
                                        movimentacao.tipo === "INCLUSAO" ||
                                        movimentacao.tipo === "REATIVACAO"
                                          ? Colors.success
                                          : "inherit",
                                    }}
                                  >
                                    {movimentacao.tipo}
                                  </TableData>
                                  <TableData>
                                    {new Date(
                                      movimentacao.data_movimentacao
                                    ).toLocaleDateString("pt-BR", {
                                      timeZone: "UTC",
                                    })}
                                  </TableData>
                                  <TableData>
                                    {movimentacao.data_fim_carencia
                                      ? new Date(
                                          movimentacao.data_fim_carencia
                                        ).toLocaleDateString("pt-BR", {
                                          timeZone: "UTC",
                                        })
                                      : ""}
                                  </TableData>
                                  <TableData>
                                    {movimentacao.observacao || "Nenhuma"}
                                  </TableData>
                                  <TableData
                                    style={{
                                      whiteSpace: "normal",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {movimentacao.tipoExclusao?.nome || "Nenhuma"}
                                  </TableData>
                                </TableRow>
                              ))}
                            </>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </Table>
                {/* adicionado um espaco para o final da tabela */}
                <Space />
              </TableContainer>
            </>
          )}

          {editOnly && (
            <ModalContainer show={showModal && editOnly}>
              <ModalContent width={50}>
                <Button
                  type="button"
                  schemaButton="x-close"
                  action={() => handleClose()}
                  icon={<IoCloseSharp size={30} />}
                  position="absolute"
                  top={10}
                  right={10}
                />
                <ModalHeader>
                  <BlueTitle>Nova movimentação</BlueTitle>
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col>
                      <Label>Nome contribuinte</Label>
                      <DisplayField>
                        {contribuinte ? contribuinte.nome : "Carregando..."}
                      </DisplayField>
                    </Col>
                    <Col>
                      <Label htmlFor="dependente">Selecione o dependente</Label>
                      <SelectComponent
                        color="black"
                        placeholder=""
                        id="dependente"
                        value={String(dependenteSelecionado || "").toString()} // Mantém o valor selecionado
                        onChange={(e) =>
                          setDependenteSelecionado(Number(e.target.value))
                        } // Atualiza o estado
                        options={[
                          {
                            value: isNewDependente
                              ? String(newDependenteData?.id || "")
                              : "",
                            label: isNewDependente
                              ? newDependenteData?.nome
                              : "Selecione",
                          },
                          // Adiciona o dependente selecionado manualmente para evitar que seja perdido
                          ...(dependenteSelecionado
                            ? dependentes
                                .filter(
                                  (dependente) =>
                                    dependente.id === dependenteSelecionado
                                )
                                .map((dependente) => ({
                                  value: String(dependente.id || ""),
                                  label: dependente.nome,
                                }))
                            : []),
                          // Filtra os dependentes com base no tipo de operação
                          ...dependentes
                            .filter((dependente) => {
                              if (tipo === "INCLUSAO") {
                                return !dependentesCadastrados.some(
                                  (cadastrado) =>
                                    cadastrado.id === dependente.id
                                );
                              } else if (
                                tipo === "EXCLUSAO" ||
                                tipo === "REATIVACAO"
                              ) {
                                return dependentesCadastrados.some(
                                  (cadastrado) =>
                                    cadastrado.id === dependente.id
                                );
                              }
                              return true;
                            })
                            .map((dependente) => ({
                              value: String(dependente.id || ""),
                              label: dependente.nome,
                            })),
                        ]}
                        disabled={isNewDependente || isNewContribuinte}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      {/* Tipo de movimentação */}
                      <SelectContainer>
                        <Label htmlFor="tipo">Tipo de movimentação</Label>
                        <SelectComponent
                          color="black"
                          id="tipo"
                          name="tipo"
                          value={tipo || ""}
                          onChange={(e) => {
                            setTipo(e.target.value as typeof tipo);
                          }}
                          options={[
                            {
                              value:
                                isNewDependente || isNewContribuinte
                                  ? "INCLUSAO"
                                  : "",
                              label:
                                isNewDependente || isNewContribuinte
                                  ? "Inclusão"
                                  : "Selecione",
                            },
                            {
                              value: "INCLUSAO",
                              label:
                                tipo === "INCLUSAO"
                                  ? " ✔ Inclusão"
                                  : "Inclusão",
                            },
                            {
                              value: "EXCLUSAO",
                              label:
                                tipo === "EXCLUSAO"
                                  ? " ✔ Exclusão"
                                  : "Exclusão",
                            },
                            {
                              value: "REATIVACAO",
                              label:
                                tipo === "REATIVACAO"
                                  ? " ✔ Reativação"
                                  : "Reativação",
                            },
                          ]}
                          disabled={isNewDependente || isNewContribuinte}
                          placeholder=""
                        />
                      </SelectContainer>
                    </Col>
                    <Col>
                      {/* Data movimentação */}
                      <InputContainer>
                        <Label htmlFor="dataMovimentacao">
                          Data movimentação
                        </Label>
                        <InputComponent
                          type="date"
                          id="inputDataMovimentacao"
                          name="dataMovimentacao"
                          value={dataMovimentacao}
                          onChange={(e) => setDataMovimentacao(e.target.value)}
                          placeholder="00/00/0000"
                          color="#333"
                        />
                      </InputContainer>
                    </Col>

                    {/* Data final carência */}
                    <Col>
                      <InputContainer>
                        <Label htmlFor="dataFimCarencia">
                          Data final carência
                        </Label>
                        <InputComponent
                          type="date"
                          name="dataFimCarencia"
                          id="dataFimCarencia"
                          value={dataFimCarencia || ""}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDataFimCarencia(selectedDate);
                          }}
                          placeholder="00/00/0000"
                          color="#333"
                          disabled={!(tipo !== "EXCLUSAO")}
                        />
                      </InputContainer>
                    </Col>
                  </Row>

                  {/* Motivo da Exclusão */}
                  {tipo === "EXCLUSAO" && (
                    <SelectContainer>
                      <Label htmlFor="motivoExclusao">Motivo da Exclusão</Label>
                      <SelectComponent
                        color="black"
                        placeholder="Selecione"
                        id="motivoExclusao"
                        name="motivoExclusao"
                        width={Number("100%")}
                        value={String(motivoExclusao || "")}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setMotivoExclusao(Number(selectedValue));
                          setErroMotivoExclusao(false);
                          clearError(e);
                        }}
                        options={[
                          ...tipoExclusao.map((tipo) => ({
                            value: String(tipo.id || ""),
                            label: tipo.nome,
                          })),
                        ]}
                        errorMessage={
                          invalidFields.includes("motivoExclusao")
                            ? "Selecione o campo motivo da exclusão"
                            : ""
                        }
                      />
                      {erroMotivoExclusao && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          Por favor, selecione um motivo para a exclusão.
                        </span>
                      )}
                    </SelectContainer>
                  )}

                  {/* Linha 3: Observação */}
                  <RowContainer>
                    <TextareaContainer>
                      <Label htmlFor="observacao">Observação</Label>
                      <Textarea
                        name="observacao"
                        id="observacao"
                        rows={5}
                        value={observacao}
                        onChange={(e) => setObservacao(e.target.value)}
                      />
                    </TextareaContainer>
                  </RowContainer>

                  {/* Botões: Cadastrar */}
                  <div
                    className="form-buttons"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginTop: "20px",
                    }}
                  ></div>
                </ModalBody>
                <ModalFooter>
                  {!isNewContribuinte && !isNewDependente && (
                    <Button schemaButton="full-secondary" action={handleClose}>
                      Cancelar
                    </Button>
                  )}

                  <Button
                    schemaButton="full-primary"
                    action={handleValidate}
                    disabled={isRequest}
                  >
                    Cadastrar movimentação
                  </Button>
                </ModalFooter>
              </ModalContent>
            </ModalContainer>
          )}
        </div>
      </div>
    </MainContainer>
  );
};

export default MovimentacaoPage;
